

import React, { useRef } from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSnackbar } from "./SnackbarContext";

function UploadDoc({
  documentType = "",
  heading = "",
  doc_name = "",
  onFileSelect,
  fileUploaded = false,
  fileUrl,
  hasError = false,
}) {
  const fileInputRef = useRef();
  const showSnackbar = useSnackbar();

  const handleCardClick = () => fileInputRef.current?.click();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg"];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    if (!allowedTypes.includes(file.type)) {
      showSnackbar("Only PDF, JPG, or JPEG files are allowed", "error");
      return;
    }

    if (file.size > maxFileSize) {
      showSnackbar("File must be less than 1 MB", "error");
      return;
    }

    onFileSelect?.(file, doc_name);
  };

  return (
    <div
      className={`
        group relative flex flex-col items-center justify-center
         w-[250px] md:w-[280px] h-[180px] mx-auto 
        border-2 border-dashed 
        ${hasError ? "border-red-500" : fileUploaded ? "border-green-400" : "border-[#b0dae5]"}
        bg-white/30 backdrop-blur-[4px] shadow-xl rounded-2xl
        cursor-pointer transition-all duration-200
        hover:bg-gradient-to-br hover:from-[#eaf5fc] hover:to-[#f0fff7]
        hover:border-[#2683C9]
      `}
      onClick={handleCardClick}
    >
      <input
        type="file"
        ref={fileInputRef}
        accept=".pdf, .jpg, .jpeg"
        className="hidden"
        onChange={handleFileChange}
      />

      {/* Preview thumb if image uploaded */}
      {fileUploaded && fileUrl && fileUrl.startsWith("data:image") ? (
        <img
          src={fileUrl}
          alt="Preview"
          className="absolute top-4 right-4 w-12 h-12 object-cover rounded-lg border-2 border-white shadow-md"
        />
      ) : null}

      <div
        className={`
          flex items-center justify-center w-14 h-14 bg-white/60 rounded-full shadow-lg
          ${fileUploaded ? "border border-green-400" : ""} mb-2
        `}
      >
        <FileUploadIcon
          className={`text-3xl ${
            fileUploaded ? "text-green-600" : "text-[#2683C9] group-hover:text-[#1fa187]"
          } transition-all`}
        />
      </div>

      <div className="flex flex-col items-center gap-1">
        <div className="text-base font-semibold text-[#1E293B]">{heading}</div>
        {fileUploaded ? (
          <div className="text-green-700 text-xs mt-1 font-medium tracking-wide">✓ File Uploaded</div>
        ) : (
          <div className="text-[13px] text-[#348abd] font-[600] underline underline-offset-2">
            Click or drag to upload
          </div>
        )}
        <div className="text-[12px] text-[#565656]">{documentType}</div>
      </div>
    </div>
  );
}

export default UploadDoc;
